function updateSlideOptions() {
  // Find all hotspot sections
  document.querySelectorAll('.image-hotspots').forEach(section => {
    const slidesData = section.dataset.slides;
    if (!slidesData) return;

    // Parse slides data
    const slides = slidesData.split(';')
      .filter(s => s)
      .map(slide => {
        const [id, number] = slide.split(',');
        return { value: id, label: `Slide ${number}` };
      });

    // Find all slide_id inputs in the theme editor
    const editor = document.querySelector('.theme-editor');
    if (!editor) return;

    // Look for select elements with name containing slide_id
    editor.querySelectorAll('select[name*="slide_id"]').forEach(select => {
      // Store current value
      const currentValue = select.value;

      // Clear existing options
      select.innerHTML = '';

      // Add default option
      const defaultOption = document.createElement('option');
      defaultOption.value = '';
      defaultOption.textContent = 'Select a slide';
      select.appendChild(defaultOption);

      // Add slide options
      slides.forEach(slide => {
        const option = document.createElement('option');
        option.value = slide.value;
        option.textContent = slide.label;
        select.appendChild(option);
      });

      // Restore selected value if it still exists
      if (slides.some(slide => slide.value === currentValue)) {
        select.value = currentValue;
      }
    });
  });
}

// Update when blocks are selected
document.addEventListener('shopify:block:select', updateSlideOptions);

// Update when sections are loaded
document.addEventListener('shopify:section:load', function() {
  // Find all slideshow components
  document.querySelectorAll('.slideshow').forEach(slideshow => {
    // Get all slides
    const slides = slideshow.querySelectorAll('.slideshow__slide');
    
    // Initialize first slide
    if (slides.length > 0) {
      slides.forEach((slide, index) => {
        slide.style.display = index === 0 ? 'block' : 'none';
      });
    }
  });
});

// Also handle block select events
document.addEventListener('shopify:block:select', function(event) {
  const block = event.target;
  if (block.classList.contains('slideshow__slide')) {
    const slideshow = block.closest('.slideshow');
    const slides = slideshow.querySelectorAll('.slideshow__slide');
    slides.forEach(slide => slide.style.display = 'none');
    block.style.display = 'block';
  }
});

// Update when blocks are added
document.addEventListener('shopify:block:load', updateSlideOptions);

// Initial load
document.addEventListener('DOMContentLoaded', updateSlideOptions);

// Update when theme editor is ready
document.addEventListener('shopify:theme-editor:ready', updateSlideOptions);

// Additional event for theme editor interactions
document.addEventListener('page:loaded', updateSlideOptions);

// Add mouse drag functionality to image hotspot slideshows
document.addEventListener('DOMContentLoaded', function() {
  const hotspotSlideshows = document.querySelectorAll('.image-hotspots slideshow-component');
  
  hotspotSlideshows.forEach(function(slideshow) {
    const slider = slideshow.querySelector('.slider--generic');
    if (!slider) return;
    
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;
    let moved = false;
    
    // Mouse down - start dragging
    slider.addEventListener('mousedown', function(e) {
      // Don't interfere with hotspot clicks
      if (e.target.closest('.hotspots__hotspot') || e.target.closest('.hotspots__button')) {
        return;
      }
      
      isDragging = true;
      moved = false;
      slider.style.cursor = 'grabbing';
      slider.style.userSelect = 'none';
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      
      e.preventDefault();
    });
    
    // Mouse leave - stop dragging
    slider.addEventListener('mouseleave', function() {
      if (isDragging) {
        isDragging = false;
        slider.style.cursor = 'grab';
      }
    });
    
    // Mouse up - stop dragging
    slider.addEventListener('mouseup', function(e) {
      if (isDragging) {
        isDragging = false;
        slider.style.cursor = 'grab';
        
        // If moved significantly, trigger slide change
        if (moved && Math.abs(e.pageX - (startX + slider.offsetLeft)) > 50) {
          const direction = e.pageX < (startX + slider.offsetLeft) ? 'next' : 'previous';
          if (slideshow.calculateFromDirection) {
            slideshow.calculateFromDirection(direction);
          }
        }
      }
    });
    
    // Mouse move - do the dragging
    slider.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      
      e.preventDefault();
      moved = true;
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; // Multiply by 2 for faster scroll
      slider.scrollLeft = scrollLeft - walk;
    });
    
    // Set cursor to grab when hovering
    slider.style.cursor = 'grab';
  });
});

class QuickAddButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onButtonClick.bind(this));
  }

  async onButtonClick() {
    const url = this.dataset.url;
    if (!url) return;

    // Add loading state
    this.classList.add('loading');
    
    try {
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const productForm = html.querySelector('product-form');

      if (productForm) {
        // Trigger add to cart
        const submitButton = productForm.querySelector('[type="submit"]');
        if (submitButton) submitButton.click();
      }
    } catch (e) {
      console.error(e);
    } finally {
      // Remove loading state
      this.classList.remove('loading');
    }
  }
}

customElements.define('quick-add-button', QuickAddButton); 